import type { RespostaWms } from "./rpc";
import type { Perfil } from "./auth";

export const ACOES_PEDIDO_MANUAL = ["consultar", "cadastrar", "editar", "cancelar", "imprimir", "alterar_situacao"] as const;
export type AcaoPedidoManual = typeof ACOES_PEDIDO_MANUAL[number];
export const ROTULOS_ACOES_PEDIDO_MANUAL: Record<AcaoPedidoManual, string> = {
  consultar: "Consultar", cadastrar: "Cadastrar", editar: "Editar", cancelar: "Cancelar", imprimir: "Imprimir", alterar_situacao: "Alterar situação",
};
export interface IdentificacaoPedido { numero?: number | null; tiny_id?: number | null; origem?: string; numero_manual?: number | null }
export function numeroPedido(p: IdentificacaoPedido): string {
  return p.origem === "MANUAL" ? `WMS-${p.numero_manual ?? p.numero ?? ""}` : String(p.numero ?? p.tiny_id ?? "");
}
export function podePedidoManual(p: Perfil | null, acao: AcaoPedidoManual): boolean {
  if (!p?.ativo) return false;
  if (p.papel === "admin") return true;
  if (p.acoes_pedidos_manuais) return p.acoes_pedidos_manuais.includes(acao);
  const papeis = [p.papel, ...(p.papeis_extras ?? []), ...(p.areas ?? [])];
  return acao === "consultar" ? papeis.some(x => ["lider", "conferente", "expedidor", "cx"].includes(x))
    : acao === "imprimir" ? papeis.some(x => ["lider", "conferente", "expedidor"].includes(x)) : papeis.includes("lider");
}
export interface ItemPedidoManual { produto_id: string; codigo: string | null; nome: string; quantidade: number; valor_unitario: number }
export interface DadosPedidoManual {
  cliente: string; vendedor: string; observacoes: string; deposito_id: string; forma_envio: string;
  numero_externo: string; nota_numero: string; nota_serie: string; nota_chave: string;
}
export interface DetalhePedidoManual extends RespostaWms {
  ok: boolean; mensagem?: string; codigo_erro?: string; editavel: boolean; repetido?: boolean;
  pedido: IdentificacaoPedido & { id: string; deposito_id: string; status: string; forma_envio: string | null;
    numero_ecommerce: string | null; nota_fiscal_numero: string | null; nota_serie: string | null; nota_chave_acesso: string | null };
  dados: { cliente: string; vendedor: string; observacoes: string; valor_total: number; versao: number; separacao_iniciada_em: string | null; cancelamento_motivo: string | null };
  itens: ItemPedidoManual[];
}
export function dadosDoPedido(d: DetalhePedidoManual): DadosPedidoManual {
  return { cliente: d.dados.cliente, vendedor: d.dados.vendedor, observacoes: d.dados.observacoes,
    deposito_id: d.pedido.deposito_id, forma_envio: d.pedido.forma_envio ?? "", numero_externo: d.pedido.numero_ecommerce ?? "",
    nota_numero: d.pedido.nota_fiscal_numero ?? "", nota_serie: d.pedido.nota_serie ?? "", nota_chave: d.pedido.nota_chave_acesso ?? "" };
}
export function valorDecimal(v: string, casas: number): number | null {
  const s = v.trim().replace(",", ".");
  if (!(new RegExp(`^\\d+(?:\\.\\d{1,${casas}})?$`)).test(s)) return null;
  const n = Number(s); return Number.isFinite(n) ? n : null;
}
export function totalPedido(itens: Array<{ quantidade: number; valor_unitario: number }>): number {
  const centavos = itens.reduce((s, i) => s + (BigInt(Math.round(i.quantidade * 1000)) * BigInt(Math.round(i.valor_unitario * 100)) + 500n) / 1000n, 0n);
  return Number(centavos) / 100;
}
